module.exports = __webpack_public_path__ + "static/media/VirgenCoromotoRelicario-Hallazgos-small.2bff398a.jpg";